import axios from 'axios'
import router from '../../../router'

export const companiesRegistrationsStore = {
  namespaced: true,
  state: {
    store: {
      name: '',
      prefecture: '',
      postal_code: '',
      lines: '',
    },
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    writeRegistrationsStore(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readRegistrationsStore(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readRegistrationsStoreSuccess(state, payload) {
      if (payload.data.length) {
        state.store = {
          id: payload.data[0].id,
          name: payload.data[0].attributes.name,
          uuid: payload.data[0].attributes.uuid,
          postal_code: payload.data[0].attributes.postal_code,
          lines: payload.data[0].attributes.lines.join(' '),
          prefecture: payload.data[0].attributes.prefecture,
        }
      }
      state.loading = false
    },
    writeRegistrationsStoreSuccess(state, payload) {
      state.store = {
        id: payload.data.id,
        name: payload.data.attributes.name,
        uuid: payload.data.attributes.uuid,
        postal_code: payload.data.attributes.postal_code,
        lines: payload.data.attributes.lines.join(' '),
        prefecture: payload.data.attributes.prefecture,
      }
      state.loading = false
      router.push('/s/companies/' + payload.companyUuid + '/registrations/stores/' + state.store.uuid + '/sites')
    },
    readRegistrationsStoreFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
    writeRegistrationsStoreFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  actions: {
    readRegistrationsStore({ commit }, routeParams) {
      commit('readRegistrationsStore')
      return axios
        .get('/api/companies/' + routeParams.companyUuid + '/registrations/brands/' + routeParams.brandId + '/stores.json')
        .then(res => {
          commit('readRegistrationsStoreSuccess', res.data)
        })
        .catch(err => {
          commit('readRegistrationsStoreFailure', err)
          console.error(err)
        })
    },
    writeRegistrationsStore({ commit, state }, routeParams) {
      if (state.loading) return
      commit('writeRegistrationsStore')
      const payload = {
        store: state.store,
      }
      if (state.store.uuid) {
        axios
          .patch('/api/companies/' + routeParams.companyUuid + '/registrations/brands/' + routeParams.brandId + '/stores/' + state.store.uuid, payload)
          .then(res => {
            const payload = res.data
            payload.companyUuid = routeParams.companyUuid
            commit('writeRegistrationsStoreSuccess', payload)
          })
          .catch(err => {
            commit('writeRegistrationsStoreFailure', err)
            console.error(err)
          })
        return
      }
      axios
        .post('/api/companies/' + routeParams.companyUuid + '/registrations/brands/' + routeParams.brandId + '/stores', payload)
        .then(res => {
          const payload = res.data
          payload.companyUuid = routeParams.companyUuid
          commit('writeRegistrationsStoreSuccess', payload)
        })
        .catch(err => {
          commit('writeRegistrationsStoreFailure', err)
          console.error(err)
        })
    }
  }
}
